import { useSelector } from "react-redux";
import { ExtractFnReturnType, QueryConfig } from "../../../lib/react-query";
import { getReportDefinitions } from "../api/reportDefinitionAPI";
import { RootState } from "../../../redux/store";
import { useQuery } from "@tanstack/react-query";
import { PaginationFilterDto } from "../../../types/Pagination";

type QueryFnType = typeof getReportDefinitions;

type UseSearchReportDefinitionsOptions = {
    config?: QueryConfig<QueryFnType>;
};

export const useReportDefinitions = ({ config }: UseSearchReportDefinitionsOptions = {}) => {
    const selectedFilters = useSelector((state: RootState) => state.filters.reportDefinitions.selectedFilters);
    const pagination = useSelector((state: RootState) => state.historical.reportDefinitions);
    const filterByCurrentUser = useSelector((state: RootState) => state.filters.reportDefinitions.filterByCurrentUser);

    const paginationFilters: PaginationFilterDto =
    {
        pageNumber: pagination.currentPage,
        pageSize: pagination.itemsPerPage,
        search: pagination.searchText,
        filterByCurrentUser: filterByCurrentUser,
        filters: selectedFilters,
        selectedOrganizationalStructureIds: []
    };


    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        retry: false,
        queryKey: ['getReportDefinitions', selectedFilters, pagination, filterByCurrentUser],
        queryFn: () => getReportDefinitions(paginationFilters),
    });
};